var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"table-head"},[_c('div',{staticClass:"table-head__cell",class:_vm.cellModifyClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }